import type { LucideIcon } from "lucide-react";

import {
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar";
import { cn } from "@/lib/utils";
import { Link, useLocation } from "react-router-dom";

export function AppSidebarNav({
  items,
  title,
}: {
  items: {
    title: string;
    url: string;
    icon?: LucideIcon;
  }[];
  title?: string;
}) {
  const location = useLocation();

  return (
    <SidebarGroup>
      {title && <SidebarGroupLabel>{title}</SidebarGroupLabel>}
      <SidebarGroupContent className="flex flex-col gap-2">
        <SidebarMenu>
          {items.map((item) => {
            // 获取当前路径的 pathname 部分，忽略 query 参数
            const currentPathname = location.pathname;
            const isActive = currentPathname === item.url;

            return (
              <SidebarMenuItem key={item.title}>
                <SidebarMenuButton
                  className={cn(
                    "min-w-8 touch-target py-3 sm:py-2 duration-200 ease-linear hover:bg-primary/5",
                    isActive
                      ? "bg-primary text-primary-foreground duration-200 ease-linear hover:bg-primary/90 hover:text-primary-foreground active:bg-primary/90 active:text-primary-foreground"
                      : "min-w-8 duration-200 ease-linear"
                  )}
                  tooltip={item.title}
                  asChild
                >
                  <Link to={item.url} className="text-sm sm:text-base">
                    {item.icon && (
                      <item.icon className="h-4 w-4 sm:h-5 sm:w-5" />
                    )}
                    <span>{item.title}</span>
                  </Link>
                </SidebarMenuButton>
              </SidebarMenuItem>
            );
          })}
        </SidebarMenu>
      </SidebarGroupContent>
    </SidebarGroup>
  );
}
